import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CmdkService {
  readonly open = signal(false);

  openCmdk(): void {
    this.open.set(true);
  }

  closeCmdk(): void {
    this.open.set(false);
  }

  toggleCmdk(): void {
    this.open.update((v) => !v);
  }
}

